import { ENVIRONMENT } from '@app/environment';
import { DOCUMENTS } from '@introspection/documents';
import { introspectionQueryResultData } from '@introspection/fragmentTypes';
import { Module } from '@rxdi/core';
import { convertToPossibleTypes, GraphqlModule, GraphQLRequest, InMemoryCache } from '@rxdi/graphql-client';
import * as firebase from 'firebase/app';

import { AiService, AnalyticsService, CategoryService, SeoService } from './services';
import { BlogService } from './services/blog/blog.service';

@Module({
  imports: [
    GraphqlModule.forRoot(
      {
        async onRequest(this: GraphQLRequest) {
          const headers = new Headers();
          const user = firebase.auth().currentUser;

          if (user) {
            headers.append('authorization', await user.getIdToken());
          }
          return headers;
        },
        cache: new InMemoryCache({
          possibleTypes: convertToPossibleTypes(introspectionQueryResultData),
        }),
        uri: ENVIRONMENT.GRAPH_URL,
        pubsub: ENVIRONMENT.GRAPH_WS_URL,
      },
      DOCUMENTS
    ),
  ],
  providers: [BlogService, CategoryService, AiService, SeoService, AnalyticsService],
})
export class CoreModule {}
